/** USB2 提示「不再显示」偏好（进入设备 / 点 16K 共用）。 */
const STORAGE_KEY = 'rapoo.gcome.usb2Tip.dismissed'

export function isUsb2TipDismissed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export function dismissUsb2Tip(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1')
  } catch {
    // ignore quota / private mode
  }
}
